import { differenceInCalendarDays, subDays } from "date-fns";

/**
 * Computes the previous period date range matching backend getTotalMetricsForAdvertiser logic.
 * @param {{ startDateTime: number, endDateTime: number }} dateRange
 * @returns {{ startDateTime: number, endDateTime: number } | null}
 */
export const getPreviousDateRange = ({ startDateTime, endDateTime }) => {
  if (!startDateTime || !endDateTime) {
    return null;
  }

  const startDt = new Date(startDateTime);
  const endDt = new Date(endDateTime);
  const days = differenceInCalendarDays(endDt, startDt) + 1;
  const previousEnd = subDays(startDt, 1);
  const previousStart = subDays(previousEnd, days - 1);

  return {
    startDateTime: previousStart.getTime(),
    endDateTime: previousEnd.getTime(),
  };
};

export default getPreviousDateRange;
